import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericResultModel } from 'src/app/sharedFeatures/models/generic-result.model';
import { BaseHttpServiceService } from 'src/app/sharedFeatures/services/base-http-service.service';
import { CurrentUserService } from 'src/app/sharedFeatures/services/current-user.service';
import { ProjectLightViewModel } from '../models/project-light-view-model.model';
import { ProjectLookupSearchModel } from '../models/project-lookup-search-model.model';
import { ProjectSearchModel } from '../models/project-search-model';
import { ProjectViewModel } from '../models/project-view-model.model';
import { ProjectViewViewModel } from '../models/project-view-view-model.model';
import { ProjectBudget } from '../models/project-budget-view-model';
import { ProjectMilestoneViewModel } from '../models/milestone-view-model';
import { ProjectMileStoneViewViewModel } from '../models/project-mileStone-view-view-model';
import {
  ProjectCalendar,
  ProjectSummaryDto,
} from '../models/project-summary-dto-view-model.model';
import { ProjectCommunicationViewViewModel } from '../models/project-communication';
import { FileData } from 'src/app/sharedFeatures/models/attchment-request';
import { SectionDto } from '../../section/models/section-summary-dto-view-model.model';
import { ProjectLookupViewModel } from '../models/project-lookup-view-model.model';
import { ProjectModel } from '../../chart/models/project-model';

@Injectable({
  providedIn: 'root',
})
export class ProjectService extends BaseHttpServiceService {
  private controller: string = `${this.baseUrl}/Project`;

  constructor(
    http: HttpClient,
    translateService: TranslateService,
    currentUserService: CurrentUserService
  ) {
    super(http, translateService, currentUserService);
  }
  search(
    model: ProjectSearchModel
  ): Observable<GenericResultModel<ProjectLightViewModel[]>> {
    let url: string = `${this.controller}/search`;
    return this.postData<GenericResultModel<ProjectLightViewModel[]>>(
      url,
      model
    );
  }
  downloadPdf(model: ProjectSearchModel): any {
    let url: string = `${this.controller}/export-pdf`;
    return this.exportData(url, model);
  }
  getProjects(model: ProjectSearchModel): Observable<ProjectSummaryDto> {
    let url: string = `${this.controller}/get-projects-card`;
    return this.postData<ProjectSummaryDto>(url, model);
  }
  getProjectsStatuses(model: ProjectSearchModel): Observable<SectionDto> {
    let url: string = `${this.controller}/getProjectsStatuses`;
    return this.postData<SectionDto>(url, model);
  }

  GetProjectsDueSoon(model: ProjectSearchModel): Observable<ProjectCalendar[]> {
    let url: string = `${this.controller}/get-projects-chart`;
    return this.postData<ProjectCalendar[]>(url, model);
  }

  getLookup(
    searchModel: ProjectLookupSearchModel
  ): Observable<GenericResultModel<ProjectLookupViewModel[]>> {
    let url: string = `${this.controller}/searchLookup`;
    return this.postData<GenericResultModel<ProjectLookupViewModel[]>>(
      url,
      searchModel
    );
  }
  getListLookup(): Observable<ProjectLookupViewModel[]> {
    let url: string = `${this.controller}/searchListLookup`;
    return this.postData<ProjectLookupViewModel[]>(url, null);
  }
  getById(id: any): Observable<ProjectViewModel> {
    let url: string = `${this.controller}/get/${id}`;
    return this.getData<ProjectViewModel>(url);
  }

  getDetailById(id: any): Observable<ProjectCommunicationViewViewModel> {
    let url: string = `${this.controller}/get-detail-comments/${id}`;
    return this.getData<ProjectCommunicationViewViewModel>(url);
  }

  getViewById(id: any): Observable<ProjectViewViewModel> {
    let url: string = `${this.controller}/details/${id}`;
    return this.getData<ProjectViewViewModel>(url);
  }
  getProjectMileStoneViewById(
    id: any
  ): Observable<ProjectMileStoneViewViewModel> {
    let url: string = `${this.controller}/project-milestone-details/${id}`;
    return this.getData<ProjectMileStoneViewViewModel>(url);
  }

  getAll(model: ProjectSearchModel): Observable<ProjectModel[]> {
    let url: string = `${this.controller}/getAll`;
    return this.postData<ProjectModel[]>(url, model);
  }
  addAttachment(id: any, fileData: FileData): Observable<any> {
    let url: string = `${this.controller}/add-attachment/${id}`;
    return this.postData<any>(url, fileData);
  }
  add(model: ProjectViewModel): Observable<ProjectViewModel> {
    let url: string = `${this.controller}/add`;
    return this.postData<ProjectViewModel>(url, model);
  }

  update(model: ProjectViewModel): Observable<ProjectViewModel> {
    let url: string = `${this.controller}/update`;
    return this.postData<ProjectViewModel>(url, model);
  }

  projectBudgets(model: ProjectBudget): Observable<ProjectViewModel> {
    let url: string = `${this.controller}/update-budget`;
    return this.postData<ProjectViewModel>(url, model);
  }
  projectPlan(model: ProjectMilestoneViewModel): Observable<ProjectViewModel> {
    let url: string = `${this.controller}/update-plan`;
    return this.postData<ProjectViewModel>(url, model);
  }
  delete(id: any): Observable<any> {
    let url: string = `${this.controller}/delete/${id}`;
    return this.postData<any>(url, null);
  }
}
